import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Testimonial, TESTIMONIALS } from '../content';
import { RevealDirective } from '../reveal.directive';

/** The first letters of a name, for the circle beside it. */
function initials(name: string): string {
  const words = name.trim().split(/\s+/);
  return (words[0][0] + (words.length > 1 ? words[words.length - 1][0] : '')).toUpperCase();
}

/**
 * Customer reviews in two rows that drift past each other. A row stops while
 * the pointer or the keyboard is on it; on touch screens, and when the visitor
 * prefers less motion, the rows stand still and are swiped instead.
 */
@Component({
  selector: 'app-testimonials',
  imports: [RevealDirective],
  templateUrl: './testimonials.html',
  styleUrl: './testimonials.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Testimonials {
  protected readonly stars = [1, 2, 3, 4, 5];
  /** the reviews, shared out over the two rows */
  protected readonly rows: Testimonial[][] = [
    TESTIMONIALS.filter((_, i) => i % 2 === 0),
    TESTIMONIALS.filter((_, i) => i % 2 === 1),
  ];
  /** each row is laid out twice end to end, so that it can loop without a seam */
  protected readonly copies = [0, 1];
  protected readonly initials = initials;
}
